import { FilterBaseComponent } from "./filter-base-component.js";
import type { ColumnData, AmbitoFilter } from "../../types/ListManagerTypes.js";
import { FILTER_OPERATORS, FilterOperator } from "../../constants/FilterConstants.js";
import { AmbitoInputComponent } from "../ambito-input/ambito-input-component.js";

/**
 * Ambito filter component for territorial search filters
 * Uses the AmbitoInputComponent as its input interface
 * Generates AmbitoFilter objects for SQL queries
 */
export class FilterAmbitoComponent extends FilterBaseComponent {
    static webComponentName: string = "form-ambito-filter";
    protected _templateId: string = 'filter-ambito-template';

    // Supported operators for ambito filters (from centralized constants)
    private static readonly OPERATORS = FILTER_OPERATORS.ambito;
    protected ambitoInput!: AmbitoInputComponent;
    protected _operator: FilterOperator = '='; // Default operator
    constructor() {
        super();
        console.log(`FilterAmbitoComponent constructor: ${this.createRandomId()}`);
    }
    get operator(): FilterOperator {
        return this._operator;
    }

    set operator(value: FilterOperator) {
        return; // No operator change allowed for ambito filters
    }
    get filterValue(): any {
        if (!this.ambitoInput) {
            return [];
        }
        return this.ambitoInput ? this.ambitoInput.value : [];
    }
    /**
     * Generate AmbitoFilter object from current UI state
     */
    generateFilter(): AmbitoFilter {

        return {
            type: 'ambito',
            columnName: this.fieldName,
            searchTerm: this.filterValue,
            operator: "="
        };
    }

    /**
     * Get available operators for ambito filters
     */
    getAvailableOperators(): string[] {
        return ['='];
    }

    /**
     * Validate filter value based on operator
     */
    validateFilterValue(): boolean {
        if (!this.ambitoInput) {
            return false;
        }

        // Check if at least one territorial area is selected
        const selectedValues = this.ambitoInput.value;
        return Array.isArray(selectedValues) && selectedValues.length > 0;
    }

    protected onPrepareData(data: Record<string, any>): Record<string, any> {
        // Override to add any additional data needed for template
        return {
            ...data,
            filterId: this.filterId,
        }
    }

    initialize(colData: ColumnData): void {
        super.initialize(colData);
    }
    rendered: boolean = false;
    protected afterRender() {
        this.ambitoInput = this.querySelector('ambito-input') as AmbitoInputComponent;
    }
    protected render(): void {
        if (this.rendered) {
            return;
        }
        super.render();
        this.rendered = true;
    }
    protected setupEventListeners(): void {
        if (this.ambitoInput) {
            // Ascoltare cambiamenti di valore dal componente figlio
            this.ambitoInput.addEventListener('ambito-value-changed', (e: Event) => {
                // this.dispatchFilterEvent("change"); // se esiste
                this.dispatchValueChange(); // nuovo standard
            });
        }
    }
}   